import { Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import FitnessTools from "./components/FitnessTools";
import ExercisesPage from "./components/ExercisesPage";
import ExercisePage from "./components/ExercisePage";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Login from "./components/Login";
import Signup from "./components/Signup";
import About from "./components/About";
import Chatbot from "./components/Chatbot";
import Blogs from "./components/Blogs";
import Blogpage from "./components/Blogpage";
import PostBuilder from "./components/PostBuilder";
import Posts from "./components/Posts";
import Post from "./components/Post";
import Chat from "./components/Chat";

function App() {
  return (
    <div className="app">
      <Navbar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/fitness-tools" element={<FitnessTools />} />
        <Route path="/about" element={<About />} />
        <Route path="/exercises" element={<ExercisesPage />}></Route>
        <Route path="/exercises/:id" element={<ExercisePage />}></Route>
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:id" element={<Blogpage />} />

        <Route path="/postbuilder" element={<PostBuilder />} />
        <Route path="/posts" element={<Posts />} />
        <Route path="/post/:postId" element={<Post />} />
        <Route path="/chat" element={<Chat />} />

        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
      </Routes>
      <Chatbot />
      <Footer />
    </div>
  );
}

export default App;
